import { useEffect, useState } from "react";
const API = "https://suivi.amservices.eu/api";

export default function Archives() {

    const [archives, setArchives] = useState([]);

    const load = async () => {
        const r = await fetch(`${API}/get_archive.php`, { credentials: "include" });
        const d = await r.json();
        if (d.success) setArchives(d.data);
    };
    useEffect(() => { load() }, []);

    const restore = async (id) => {
        await fetch(`${API}/restore.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id })
        })
        load();
        alert("Restauré ✔");
    };

    const remove = async (id) => {
        if (!window.confirm("Supprimer définitivement ?")) return;
        await fetch(`${API}/delete_archive.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id })
        })
        load();
    };

    return (
        <div className="admin-page">
            <div className="page-content">
                <h1>📦 Archives</h1>

                <table className="repair-table">
                    <thead>
                        <tr>
                            <th>Client</th><th>Téléphone</th><th>Appareils</th>
                            <th>Note</th><th>Archivé le</th><th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {archives.map(a =>
                            <tr key={a.id}>
                                <td>{a.client}</td>
                                <td>{a.tel}</td>
                                <td>{a.appareils}</td>
                                <td>{a.note || "—"}</td>
                                <td>{a.archived_at}</td>
                                <td className="actions-menu">
                                    <button className="btn-recup" onClick={() => restore(a.id)}>↩</button>
                                    <button className="btn-archive" onClick={() => remove(a.id)}>🗑</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
